/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

import theme from "assets/theme";

import themeDark from "assets/theme-dark";

import { superAdminRoutes, adminRoutes } from "routes";
import NotFoundPage from "./NotFoundPage";

import { useMaterialUIController, setMiniSidenav } from "context";

import minibrand from "assets/images/image2.png";
import brandWhite from "assets/images/DTC.png";
import brandDark from "assets/images/112.png";

import "./App.css";
import { getDecodedUserData } from "utils/Constant";


export default function App() {

  const userRole = getDecodedUserData()?.role;

  const [routes, setRoutes] = useState(superAdminRoutes);

  useEffect(() => {
    if (userRole === "Admin") {
      const signOutRoute = superAdminRoutes.find(
        (route) => route.key === "sign-out"
      );
      const updatedRoutes = superAdminRoutes.filter(
        (route) => route.key !== "sign-out"
      );

      setRoutes([...updatedRoutes, ...adminRoutes, signOutRoute]);
    } else {
      setRoutes(superAdminRoutes);
    }
  }, [userRole, superAdminRoutes]);

  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, transparentSidenav, whiteSidenav, darkMode } = controller;

  const { pathname } = useLocation();

  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;

    if (window.innerWidth < 1200) {
      setMiniSidenav(dispatch, true);
    }
  }, [pathname, dispatch]);

  const getRoutes = (allRoutes = []) =>
    allRoutes
      .filter((r) => r && typeof r === "object")
      .flatMap((route) => {
        if (route.collapse) {
          return getRoutes(route.collapse);
        }

        if (route.route) {
          return (
            <Route
              exact
              path={route.route}
              element={route.component}
              key={route.key}
            />
          );
        }

        return [];
      });

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color="primary"
            brand={
              (transparentSidenav && !darkMode) || whiteSidenav
                ? brandDark
                : brandWhite
            }
            brandName=""
            hoverBrand={minibrand}
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ThemeProvider>
  );
}
